import React from "react"

import Page from "./page"

const PageTemplate = props => {
    return <Page {...props} />
} 

export default PageTemplate
